import { useState, useCallback } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export function useConsentModal() {
  const [state, setState] = useState({ show: false, resolve: null, checked: true });

  const confirmWithConsent = useCallback(() => {
    return new Promise((resolve) => {
      setState({ show: true, resolve, checked: true });
    });
  }, []);

  const handleConfirm = () => {
    state.resolve(true);
    setState({ show: false, resolve: null, checked: true });
  };

  const handleCancel = () => {
    state.resolve(false);
    setState({ show: false, resolve: null, checked: true });
  };

  const ConsentModalJSX = (
    <Modal show={state.show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Save</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Check
          type="checkbox"
          id="consent-checkbox"
          label="I hereby ensure that the entered data are correct and accurate to the best of my knowledge."
          checked={state.checked}
          onChange={(e) => setState((prev) => ({ ...prev, checked: e.target.checked }))}
          className="fs-6"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleConfirm} disabled={!state.checked}>
          <i className="bi bi-floppy me-1"></i>Save
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return { confirmWithConsent, ConsentModalJSX };
}
